import React, { Component } from "react";
import '../css/documentation.scss';

export class ViewScheduledMovieVoucherHelp extends Component {
    render() {
        return (
            <div className="main-content">
                <div className="section__content section__content--p30 createContent">
                    <div className="container-fluid">
                        <h1 style={{ fontSize: '36px', marginTop: '30px' }}>How To View Scheduled Movie Voucher</h1>
                        <p className="dateFormat" style={{ fontSize: '14px', color: 'grey' }}>18/11/2021 ▪ 2 minutes to read</p>
                        <br /><br />
                        <div class="webMgmt container-fluid">
                            <ol>
                                <li class="createList">
                                    Using the menu on the left, click on "Website Management", then click on the “Movie Vouchers” link. This will take you to the Movie Vouchers Listing Page.<br />
                                    <img src="/img/documentation-img/MovieVchImg/navbar.png" class="userImage" />
                                </li>
                                <li class="createList">
                                    To view a scheduled movie voucher, click on “Scheduled Publishing” in the top right corner of the Movie Vouchers Listing Page.<br />
                                    <img src="/img/documentation-img/MovieVchImg/listing_scheduled.png" class="userImage" />
                                </li>
                                <li class="createList">
                                    In the Scheduled Movie Vouchers Listing Page, click on any the scheduled movie voucher listing of your choice. This will take you to the View Scheduled Movie Vouchers Details.<br />
                                    <img src="/img/documentation-img/MovieVchImg/scheduled_select.png" class="userImage" />
                                </li>
                                <li class="createList">
                                    In Scheduled Movie Vouchers Details Page, you will be able to see the following fields:
                                    <ul class="unorderedList">
                                        <li>
                                            Voucher Code
                                        </li>
                                        <li>
                                            Voucher Program Name
                                        </li>
                                        <li>
                                            Pricing Information
                                        </li>
                                        <li>
                                            Voucher Category
                                        </li>
                                        <li>
                                            Display Start DateTime
                                        </li>
                                        <li>
                                            Display End DateTime
                                        </li>
                                        <li>
                                            Display Weight
                                        </li>
                                        <li>
                                            Voucher Description
                                        </li>
                                        <li>
                                            Voucher Image
                                        </li>

                                    </ul>
                                    <div class="alert alert-primary" role="alert">
                                        <i class="fas fa-info-circle" aria-hidden="true"></i>
                                        <strong class="noteHeader">Information:</strong><br/><br/>
                                            - Display weight determines how the item will be displayed. The lower the display weight, the higher it will place on the website.<br />
                                            - Display Start DateTime should always be earlier than Display End DateTime.<br />
                                            - Voucher Description should be in HTML format.
                                </div>
                            </li>



                            </ol>
                            <div className="text-right">
                                <a href="/documentation/movievouchers/EditMovieVoucherHelp" className="btn btn-primary">&laquo; Edit Movie Voucher</a>&nbsp;
                                <a href="/documentation/movievouchers/EditScheduledMovieVoucherHelp" className="btn btn-primary">Edit Scheduled Movie Voucher &raquo;</a>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
        );
    }
}